import { MainButton } from 'elements/button/MainButton';
import { DetailQuery_moment_cards_InstagramCard } from 'graphql/query/__generated__/DetailQuery';
import { useIsWide } from 'libs/utils/logic/ui/responsiveLogic';
import { useEffect, useState } from 'react';
import { InstagramEmbed } from 'react-social-media-embed';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

interface Props {
    card: DetailQuery_moment_cards_InstagramCard;
    className?: string;
}

export const InstagramCard = (props: Props): JSX.Element => {
    const [loading, setLoading] = useState(true);
    const postId = props.card.instagram.postId;
    const isWide = useIsWide();

    //For edit panel refresh
    useEffect(() => {
        setLoading(true);
        setTimeout(() => {
            setLoading(false);
        }, 50);
    }, [postId]);

    if (!postId) return <></>;

    return (
        <S_InstagramCard className={props.className}>
            {!loading && <InstagramEmbed url={postId} width={isWide ? 443 : 340} />}
            <S_Link href={postId} target="_blank" rel="noreferrer">
                <MainButton
                    type="event-secondary"
                    iconSet="far"
                    iconName="arrow-up-right-from-square"
                >
                    {Localization.OPEN_INSTAGRAM}
                </MainButton>
            </S_Link>
        </S_InstagramCard>
    );
};

const S_InstagramCard = styled.div`
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    overflow: hidden;
`;

const S_Link = styled.a`
    margin: 5px 0 0 0;
`;
